<app-base-servico
  [servico]="servico"
  [activeIndex]="ACTIVE_INDEX"
  [solicitanteTemplate]="solicitanteTemplate"
  [servicoTemplate]="servicoTemplate"
  [confirmacaoTemplate]="confirmacaoTemplate"
>
</app-base-servico>

<ng-template #solicitanteTemplate>
  <form
    [formGroup]="formSolicitante"
    (ngSubmit)="putDadosSolicitante()"
    class="flex gap-2 flex-column"
  >
    <label>CNPJ da Empresa/Associação:</label>
    <p-inputMask
      #cnpj
      id="cnpj"
      [unmask]="true"
      mask="99.999.999/9999-99"
      formControlName="cnpj"
    />
    <label>Nome da Empresa/Associação:</label>
    <input
      pInputText
      id="nome"
      formControlName="nome"
      autocomplete="off"
      aria-label="Nome da Empresa/Associação"
      style="max-width: 350px"
    />
    <label>Endereço:</label>
    <input
      pInputText
      id="endereco"
      formControlName="endereco"
      autocomplete="off"
      aria-label="Endereço"
      style="max-width: 350px"
    />
    <label>Celular:</label>
    <p-inputMask
      id="telefone"
      mask="(99) 99999-9999"
      formControlName="telefone"
      autocomplete="off"
      ariaLabel="Celular"
    />
    <label>E-mail:</label>
    <input
      pInputText
      id="email"
      formControlName="email"
      autocomplete="off"
      aria-label="E-mail"
      style="max-width: 350px"
    />
    <label>Responsável para contato:</label>
    <input
      pInputText
      id="responsavel"
      formControlName="responsavel"
      autocomplete="off"
      aria-label="Responsável para contato"
      style="max-width: 350px"
    />

    <h4 class="subtitulo">Declaração de Veracidade</h4>
    <p style="font-size: 12px; margin-top: 10px">
      Declaro que as informações prestadas e documentos apresentados são
      verdadeiros e estou ciente de que, em caso de vistoria "in loco", havendo
      divergência nas informações declaradas, estarei sujeito as sansões e
      penalidades e ao pagamento da indenização da diferença dos valores entre
      as tarifas aplicadas, ao preço vigente na ocasião da vistoria.
    </p>

    <p-checkbox
      formControlName="declaracaoVeracidade"
      value="aceite"
      inputId="declaracaoVeracidade"
      label="Li e concordo"
    ></p-checkbox>
    <h4 class="subtitulo">Declaração de Aceite</h4>
    <p style="font-size: 12px; margin-top: 10px">
      Estou ciente de que em caso de não envio da documentação compromissada,
      após a análise da CASAN, será gerada a REJEIÇÃO IMEDIATA do atendimento e
      será necessária a abertura de uma nova solicitação, com a documentação
      completa. Lembramos que sempre que necessário, a CASAN se reserva ao
      direito de solicitar outros documentos além dos já requeridos, de acordo
      com a peculiaridade de cada caso.
    </p>

    <p-checkbox
      formControlName="declaracaoAceite"
      value="aceite"
      inputId="declaracaoAceite"
      label="Li e concordo"
    ></p-checkbox>

    <button
      pButton
      type="submit"
      [disabled]="formSolicitante.invalid || formSolicitante.disabled"
      label="Próximo"
      class="botao-proximo"
      [loading]="loading"
    ></button>
  </form>
</ng-template>

<ng-template #servicoTemplate>
  <form
    *ngIf="servico"
    (ngSubmit)="concluirCadastro()"
    [formGroup]="formServico"
    style="display: flex; flex-direction: column; gap: 4px"
  >
    <div class="form_wrapper">
      <label
        >Preencha no quadro abaixo as informações da sua solicitação
        <i>(OBRIGATÓRIO)</i>:</label
      >
      <textarea
        pInputTextarea
        rows="5"
        formControlName="informacoes"
        [placeholder]="servico.informacoes"
        class="w-full lg:w-9"
        style="resize: none"
        maxlength="4000"
      ></textarea>

      <ng-container *ngFor="let campo of servico?.servicoFormulario">
        <label for="campo_{{ campo.id }}">{{ campo.label }}</label>

        <p-dropdown
          [formControlName]="campo.id"
          [options]="campo.servicoValores"
          optionLabel="valor"
        ></p-dropdown>
      </ng-container>
    </div>

    <h4 class="subtitulo">DOCUMENTOS DIGITALIZADOS</h4>
    <ng-container *ngFor="let campo of servico?.servicoAnexos">
      <p-fileUpload
        [disabled]="loading"
        [showUploadButton]="false"
        [fileLimit]="1"
        [maxFileSize]="arquivosManager.TAMANHO_MAXIMO_ARQUIVOS"
        chooseLabel="Selecionar arquivo"
        cancelLabel="Limpar arquivos"
        class="file"
        accept="image/*,application/pdf"
        invalidFileSizeMessageSummary="Tamanho máximo de arquivo excedido"
        invalidFileSizeMessageDetail="Tamanho máximo do arquivo é de {0}"
        invalidFileTypeMessageSummary="Tipo de arquivo inválido"
        invalidFileTypeMessageDetail="Os arquivos permitidos são: {0}"
        invalidFileLimitMessageSummary="Número de arquivos máximo excedido"
        invalidFileLimitMessageDetail="Número máximo de arquivos é de {0}"
        (onSelect)="arquivosManager.onFileSelect($event, campo.nomeAnexo)"
        (onRemove)="arquivosManager.onFileRemove($event, campo.nomeAnexo)"
        (onClear)="arquivosManager.onClearFiles($event, campo.nomeAnexo)"
      >
        <ng-template pTemplate="toolbar">
          <div class="py-3">{{ campo.label }}</div>
          <sub style="color: red"
            ><i *ngIf="campo.envioObrigatorio">Envio Obrigatório</i></sub
          >
        </ng-template>
      </p-fileUpload>
    </ng-container>
    <h4 class="subtitulo">DOCUMENTOS COMPLEMENTARES DIGITALIZADOS</h4>
    <p-fileUpload
      [disabled]="loading"
      [showUploadButton]="false"
      [fileLimit]="3"
      [multiple]="true"
      [customUpload]="true"
      [maxFileSize]="arquivosManager.TAMANHO_MAXIMO_ARQUIVOS"
      chooseLabel="Selecionar arquivos"
      cancelLabel="Limpar arquivos"
      class="file"
      accept="image/*,application/pdf"
      invalidFileSizeMessageSummary="Tamanho máximo de arquivo excedido"
      invalidFileSizeMessageDetail="Tamanho máximo do arquivo é de {0}"
      invalidFileTypeMessageSummary="Tipo de arquivo inválido"
      invalidFileTypeMessageDetail="Os arquivos permitidos são: {0}"
      invalidFileLimitMessageSummary="Número de arquivos máximo excedido"
      invalidFileLimitMessageDetail="Número máximo de arquivos é de {0}"
      (onSelect)="
        arquivosManager.onFileSelect(
          $event,
          arquivosManager.ANEXO_DOCUMENTO_OUTROS
        )
      "
      (onRemove)="
        arquivosManager.onFileRemove(
          $event,
          arquivosManager.ANEXO_DOCUMENTO_OUTROS
        )
      "
      (onClear)="
        arquivosManager.onClearFiles(
          $event,
          arquivosManager.ANEXO_DOCUMENTO_OUTROS
        )
      "
    >
      <ng-template pTemplate="toolbar">
        <div class="py-3">
          <p>Documentos Complementares</p>
          <sub>É PERMITIDO SELECIONAR ATÉ 3 ARQUIVOS</sub>
        </div>
      </ng-template>
    </p-fileUpload>
    <button
      pButton
      type="submit"
      [disabled]="
        formServico.invalid ||
        formServico.disabled ||
        !isArquivosObrigatoriosSelecionados()
      "
      [loading]="loading"
      label="Próximo"
      class="botao-proximo"
    ></button>
  </form>
</ng-template>

<ng-template #confirmacaoTemplate>
  <app-confirmacao-solicitacao
    class="fadein animation-duration-500"
    [dadosConfirmacao]="dadosSolicitacao"
  ></app-confirmacao-solicitacao>
</ng-template>
